import React from 'react'

// material ui
import Box from '@mui/material/Box'
import Paragraph from 'components/atoms/Paragraph'

// shared components
import Typography from '@mui/material/Typography'

const SevereFoodAllergyInfo = props => (
  <Box py={2}>
    <Typography color='error.main'>
      Due to the severity of the allergy indicated in your camper's profile, they will not be able to participate in any food activities, such as The Bakery, and you will be required to bring food from home each day your child attends our program
    </Typography>
    <Paragraph />
    <Typography color='error.main'>
      Since all camp food is prepared off-site, we are unable to guarantee our provided lunch, snack items and food activities meet the necessary cross-contamination regulations to serve children with severe allergies. Please note that packed food must be ready-to-eat as lunch refrigeration and/or heating is unavailable on site.
    </Typography>
  </Box>
)

export default SevereFoodAllergyInfo

